import { gql } from "@apollo/client";

// Common API key fragment — keep in sync with the ApiKey type in
// server/graphql/types/ApiKey.graphql. We deliberately do NOT include the
// secret here because the server never returns it from queries.
export const API_KEY_FRAGMENT = gql`
  fragment ApiKeyFields on ApiKey {
    id
    scope
    ownerId
    ownerType
    name
    role
    createdByUserId
    createdAt
    updatedAt
    expiresAt
    lastUsedAt
    revokedAt
    allowListIp
    rateLimitSustained
    rateLimitBurst
    status
    v2Enrolled
    minimumApiVersion
    permissions
  }
`;

export const GET_API_KEYS = gql`
  ${API_KEY_FRAGMENT}
  query apiKeys($scope: ApiKeyScope!) {
    apiKeys(scope: $scope) {
      ...ApiKeyFields
    }
  }
`;

export const GET_API_KEY = gql`
  ${API_KEY_FRAGMENT}
  query apiKey($id: ID!) {
    apiKey(id: $id) {
      ...ApiKeyFields
    }
  }
`;

export const GET_API_KEY_METRICS = gql`
  query apiKeyMetrics($apiKeyId: ID!, $days: Int) {
    apiKeyMetrics(apiKeyId: $apiKeyId, days: $days) {
      id
      apiKeyId
      hourBucket
      totalCalls
      totalErrors
      byRoute {
        route
        calls
        errors
      }
    }
  }
`;

export const GET_API_KEY_PERMISSION_CATALOGUE = gql`
  query apiKeyPermissionCatalogue($scope: ApiKeyScope!) {
    apiKeyPermissionCatalogue(scope: $scope) {
      permissions {
        name
        roles
        sensitive
        assignable
      }
      groups {
        id
        permissions
        sensitivePermissions
      }
      presets {
        id
        permissions
      }
    }
  }
`;

export const CREATE_API_KEY = gql`
  ${API_KEY_FRAGMENT}
  mutation createApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      apiKey {
        ...ApiKeyFields
      }
      secret
    }
  }
`;

export const REVOKE_API_KEY = gql`
  mutation revokeApiKey($id: ID!) {
    revokeApiKey(id: $id)
  }
`;

export const ROTATE_API_KEY = gql`
  ${API_KEY_FRAGMENT}
  mutation rotateApiKey($id: ID!) {
    rotateApiKey(id: $id) {
      apiKey {
        ...ApiKeyFields
      }
      secret
    }
  }
`;

export const UPDATE_API_KEY = gql`
  ${API_KEY_FRAGMENT}
  mutation updateApiKey($id: ID!, $input: UpdateApiKeyInput!) {
    updateApiKey(id: $id, input: $input) {
      ...ApiKeyFields
    }
  }
`;
